import { FeatureSwitchQuery } from "../featureSwitches/FeatureSwitchQuery";
import { FeatureSwitchesResponse } from "../featureSwitches/IFeatureSwitchManager";
import { mocksResponse } from "../utils/env";
import { API } from "./API";
import { encodeQueryStringParams } from "./helpers";
import MockFeatureSwitchesResponse from "./mocks/getFeatureSwitches.json";

export async function getFeatureSwitches(query: FeatureSwitchQuery): Promise<FeatureSwitchesResponse> {
  if (mocksResponse()) {
    // return mocked response instead of CORS error
    return MockFeatureSwitchesResponse as FeatureSwitchesResponse;
  }
  return await API.call<FeatureSwitchesResponse>(`/api/featureSwitch?${encodeQueryStringParams(query)}`);
}
